import { render, staticRenderFns } from "./MultipleAccountInput.vue?vue&type=template&id=fd906450"
import script from "./MultipleAccountInput.vue?vue&type=script&lang=js"
export * from "./MultipleAccountInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports